import styled from 'styled-components';
import {SurfaceColor, OnSurface, DividerColor} from '../../Colors';

export default{
	Primary : styled.div`
        padding:1rem;
        border : 1px dotted ${DividerColor};
        color : ${OnSurface};
		background-color : ${SurfaceColor};
		overflow: auto;
    `,
};